import axios from "axios";

export function getStaff(s: string = '', club: string = '', season: string = '', sortbyfield: string = 'updated_at', sortbytype: string = 'DESC') {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/staff';
    const params = [];
    if (s.length > 0) {
        params.push('s=' + s);
    }
    if (club.length > 0) {
        params.push('club=' + club);
    }
    if (season.length > 0) {
        params.push('season=' + season);
    }
    if (sortbyfield.length > 0) {
        params.push('sortbyfield=' + sortbyfield);
    }
    if (sortbytype.length > 0) {
        params.push('sortbytype=' + sortbytype);
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function getStaffOptions(club_id: '') {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/staff/options/' + club_id;
    return axios.get(endpointUrl, { headers: headers } );
}

export function getStaffSingle(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    const getEventsUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/staff/' + id;
    return axios.get(getEventsUrl, { headers: headers } );
}

export function createStaff(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/staff';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateStaff(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/staff';
    return axios.patch(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function deleteStaff(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/staff/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}

export function getStaffTeamSeason(team_id: number, season_id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/team-season-staffs/' + team_id + '/' + season_id;
    return axios.get(endpointUrl, { headers: headers });
}

export function getStaffTeamSeasons(staff_id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/staff-team-season/' + staff_id;
    return axios.get(endpointUrl, { headers: headers });
}

export function getTeamSeasonStaffs(team_id: number, season_id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/team-season-staffs/' + team_id + '/' + season_id;
    return axios.get(endpointUrl, { headers: headers });
}

export function createStaffTeamSeason(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/staff-team-season';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function deleteStaffTeamSeason(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/staff-team-season/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}